import { render, staticRenderFns } from "./BLoggedUser.vue?vue&type=template&id=5d66dce4&scoped=true"
import script from "./BLoggedUser.vue?vue&type=script&setup=true&lang=ts"
export * from "./BLoggedUser.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BLoggedUser.vue?vue&type=style&index=0&id=5d66dce4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d66dce4",
  null
  
)

export default component.exports